export default "__VITE_ASSET__CsRHDOwI__"